import React, { useState } from "react";
import { Select, Table } from "antd";
import { BacktestSel, BacktestType } from "@/features/backtest";
import { useRootSelector } from "@/infrastructure/hooks";
import { useStatsDat } from "./hook";

const { Option } = Select;

type Props = {
  selectKey: keyof BacktestType.PortfolioStats;
};

export default ({ selectKey }: Props) => {
  const availableResultType = useRootSelector(BacktestSel.availableResultType);
  const [comparison, setComparison] = useState(availableResultType[1].key);
  const data = useStatsDat(comparison, selectKey);

  const columns = [
    {
      title: "Stats",
      dataIndex: "stats",
      key: "stats"
    },
    {
      title: "Strategy",
      dataIndex: "strategy",
      key: "strategy"
    },
    {
      title: (
        <Select value={comparison} style={{ width: 200 }} onChange={setComparison}>
          {availableResultType.slice(1).map(e => (
            <Option value={e.key} key={e.key}>
              {e.name}
            </Option>
          ))}
        </Select>
      ),
      dataIndex: "comparison",
      key: "comparison"
    }
  ];

  return <Table columns={columns} dataSource={data} pagination={false} />;
};
